<template>
    <chart type="line" :data="chartData"/>
</template>

<script>
import chart from '@/components/ui/chart/chart.vue'

export default {
    components: { chart },
    props: {
        years: {
            type: Array,
            default: []
        },
        targetObj: {
            type: Object,
            default: {}
        }
    },
    computed: {
        indexList() { return this.$store.state.card?.businessIndex?.indexList },
        datasets() {
            return this.indexList.map(e => ({
                fill: false,
                label: e.label,
                backgroundColor: e.color,
                borderColor: e.color,
                pointBorderColor: e.color,
                pointBackgroundColor: '#fff',
                borderWidth: 1,
                data: this.$props.years.map(y => this.$props.targetObj[y][e.key])
            }))
        },
        chartData() {
            return {
                labels: this.$props.years,
                datasets: this.datasets
            }
        }
    }
}
</script>